import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Loan({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M3.33341 3.33331C2.96522 3.33331 2.66675 3.63179 2.66675 3.99998V7.99998C2.66675 8.36817 2.96522 8.66665 3.33341 8.66665H5.33341V7.33331H4.00008V4.66665H20.0001V7.33331H18.6667V8.66665H20.6667C21.0349 8.66665 21.3334 8.36817 21.3334 7.99998V3.99998C21.3334 3.63179 21.0349 3.33331 20.6667 3.33331H3.33341Z"
        fill={iconColor}
      />
      <Path
        d="M6.66675 6.66665V21.3333C6.66675 21.7015 6.96522 22 7.33342 22H16.6667C17.0349 22 17.3334 21.7015 17.3334 21.3333V6.66665H16.0001V20.6666H8.00008L8.00008 6.66665H6.66675Z"
        fill={iconColor}
      />
      <Path
        d="M12.0001 14C10.8955 14 10.0001 13.1045 10.0001 12C10.0001 10.8954 10.8955 9.99998 12.0001 9.99998C13.1047 9.99998 14.0001 10.8954 14.0001 12C14.0001 13.1045 13.1047 14 12.0001 14Z"
        fill={iconColor}
      />
    </Svg>
  );
}
